import React, { ReactNode } from 'react';

import { VideoModal } from '../../../../layouts/VideoModal';
import { ImageProps } from '../../../../components/Image/types';

export interface ClientVideoProps {
  VideoPlayer?: ReactNode;
  onClickVideoThumbnail?: any;
  image?: ImageProps;
  logo?: ImageProps;
  classnameThumbnail?: string;
  classnameBoxThumbnail?: string;
}

export const ClientVideo = ({
  VideoPlayer,
  image,
  logo,
  classnameThumbnail,
  onClickVideoThumbnail,
  classnameBoxThumbnail,
}: ClientVideoProps) => {
  return (
    <VideoModal
      logo={logo}
      image={image}
      VideoPlayer={VideoPlayer}
      onClick={onClickVideoThumbnail}
      classnameThumbnail={classnameThumbnail}
      classnameBoxThumbnail={classnameBoxThumbnail}
    />
  );
};
